import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <footer className="footer select-none [-webkit-touch-callout:none] [-webkit-user-select:none]">
      <div className="container-fixed">
        <div className="flex flex-wrap gap-5 py-5 max-sm:gap-2">
          <div className="flex items-center gap-2.5">
            <div className="text-gray-500 text-2sm">
              {`${new Date().getFullYear()} ©`}
            </div>
            <div className="text-gray-5D5D5D font-medium text-2sm">
              Trustoo.
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-8 [&_a]:border-l [&_a]:border-gray-300 [&_a]:pl-6 [&_a]:text-gray-500 [&_a]:text-2sm [&_a]:hover:cursor-pointer max-sm:w-full max-sm:gap-2 max-sm:text-2xs max-sm:[&_a]:pl-2 max-sm:[&_a:first-of-type]:border-l-0 max-sm:[&_a:first-of-type]:pl-0 max-[360px]:flex-col max-[360px]:items-start max-[360px]:gap-0 max-[360px]:[&_a]:border-l-0 max-[360px]:[&_a]:pl-0">
            <a onClick={() => navigate('/privacy-policy')}>
              {t('privacyPolicy')}
            </a>
            <a onClick={() => navigate('/cgu')}>CGU</a>
            <a onClick={() => navigate('/legal-mention')}>
              {t('legalMentions')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
